import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

/** Throws on non-2xx so SWR reports an error instead of treating an error
 *  body as data (the plain fetcher swallows HTTP status). */
const listingsFetcher = async (url: string) => {
	const res = await fetch(url)
	const json = await res.json().catch(() => null)
	if (!res.ok || !Array.isArray(json)) {
		throw new Error(json?.message || `recent-listings ${res.status}`)
	}
	return json
}

/** Newest live listings across the marketplace (homepage "Listings" tab). */
export default function useRecentListings(limit = 50) {
	return useSwr(`${API_URL}/inscriptions/recent-listings?limit=${limit}`, listingsFetcher, {
		refreshInterval: 15000,
		revalidateOnFocus: true,
		keepPreviousData: true
	})
}
